import React from "react";

const TONE = {
  success: {
    label: "Listo",
    accent: "#059669",
    iconBg: "rgba(16, 185, 129, 0.14)",
    icon: "pi-check",
  },
  error: {
    label: "Error",
    accent: "#e11d48",
    iconBg: "rgba(244, 63, 94, 0.12)",
    icon: "pi-times",
  },
  warning: {
    label: "Revisá esto",
    accent: "#FA7317",
    iconBg: "rgba(250, 115, 23, 0.14)",
    icon: "pi-exclamation-triangle",
  },
  info: {
    label: "Cotify",
    accent: "#FA7317",
    iconBg: "rgba(250, 115, 23, 0.12)",
    icon: "pi-info-circle",
  },
};

/** Toast light glassmorphism — entra desde la derecha. */
export function ToastCard({ tone = "info", message, onDismiss, durationMs = 4200 }) {
  const t = TONE[tone] || TONE.info;

  return (
    <div
      className={`cotify-toast cotify-toast--${tone}`}
      style={{
        "--t-accent": t.accent,
        "--t-icon-bg": t.iconBg,
        "--t-duration": `${durationMs}ms`,
      }}
      role="status"
    >
      <div className="cotify-toast__glow" aria-hidden="true" />

      <div
        className="cotify-toast__icon"
        style={{ background: t.iconBg, color: t.accent }}
        aria-hidden="true"
      >
        <i className={`pi ${t.icon}`} />
      </div>

      <div className="cotify-toast__content">
        <span className="cotify-toast__chip" style={{ color: t.accent }}>
          {t.label}
        </span>
        <p className="cotify-toast__text">{message}</p>
      </div>

      <button
        type="button"
        className="cotify-toast__dismiss"
        aria-label="Cerrar"
        onClick={onDismiss}
      >
        <i className="pi pi-times" />
      </button>

      <span className="cotify-toast__timer" aria-hidden="true" />
    </div>
  );
}

export default ToastCard;
